module.exports = __webpack_public_path__ + "img/16 Animation 2-squashed.14786447.jpg";